<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="700">
      <v-card>
        <v-btn @click="$emit('closeModal')" text icon style="position: absolute; right: 0">
          <v-icon>close</v-icon>
        </v-btn>
        <v-card-title class="headline">{{ !input.id ? 'ADD' : 'EDIT' }}</v-card-title>
        <v-card-text>
          <v-layout v-if="input.dayname == '{default}' && input.id == '4'" row wrap>
            <v-flex xs9 sm9>
              <div class="form-control" :class="{ 'has-error': errors.has('messageInput') }">
                <label class="subtitle-2 font-weight-bold">Default Message</label>
                <input
                  v-model="input.defaultMessage"
                  type="text"
                  placeholder="ขออภัย........"
                  name="messageInput"
                  v-validate="'required'"
                />
                <span class="text-error" v-show="errors.has('messageInput')">{{
                  errors.first('messageInput')
                }}</span>
              </div>
            </v-flex>
          </v-layout>
          <v-layout v-else row wrap>
            <v-flex xs5 sm5 class="mr-2">
              <div class="form-control">
                <label class="subtitle-2 font-weight-bold">Date From:</label>
                <input
                  @click="Object.assign(picker, { open: true, type: 'From' })"
                  :value="input.dateFrom | dateFormat"
                  type="text"
                  readonly
                />
              </div>
            </v-flex>
            <v-flex xs5 sm5>
              <div class="form-control">
                <label class="subtitle-2 font-weight-bold">Date To:</label>
                <input
                  @click="Object.assign(picker, { open: true, type: 'To' })"
                  :value="input.dateTo | dateFormat"
                  type="text"
                  readonly
                />
              </div>
            </v-flex>
            <v-flex xs5 sm5>
              <div class="form-control" :class="{ 'has-error': errors.has('nameInput') }">
                <label class="subtitle-2 font-weight-bold">Name</label>
                <input
                  name="nameInput"
                  v-validate="'required'"
                  v-model="input.dayname"
                  type="text"
                  placeholder="........ Day"
                />
                <span class="text-error" v-show="errors.has('nameInput')">{{
                  errors.first('nameInput')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs9 sm9>
              <div class="form-control" :class="{ 'has-error': errors.has('messageInput') }">
                <label class="subtitle-2 font-weight-bold">Default Message</label>
                <input
                  v-model="input.defaultMessage"
                  type="text"
                  placeholder="ขออภัย........"
                  name="messageInput"
                  v-validate="'required'"
                />
                <span class="text-error" v-show="errors.has('messageInput')">{{
                  errors.first('messageInput')
                }}</span>
              </div>
            </v-flex>
          </v-layout>

          <v-dialog
            v-model="picker.open"
            :return-value.sync="date"
            persistent
            lazy
            full-width
            width="290px"
          >
            <v-date-picker
              v-model="input['date' + picker.type]"
              @change="picker.open = false"
            ></v-date-picker>
          </v-dialog>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outline color="grey" @click="$emit('closeModal')">CANCEL</v-btn>
          <v-btn
            depressed
            color="primary"
            :loading="loading"
            :disabled="loading"
            @click="!input.id ? create(input) : update(input)"
            >{{ !input.id ? 'ADD' : 'EDIT' }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Modal from '@/components/elements/Modal'
import api from '@/api'
import { mapGetters } from 'vuex'
import format from 'date-fns/format'

export default {
  props: ['type', 'dialog', 'input'],
  data() {
    return {
      loading: false,
      picker: { open: false, type: '' },
      date: ''
    }
  },
  computed: {
    ...mapGetters({ selectedBot: 'selectedBot' })
  },

  methods: {
    create(data) {
      let vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        } else {
          vm.loading = true
          api.generaliinsertholiday(
            { ...data, pageid: this.selectedBot.pageid },
            function (error, response) {
              if (error) {
                console.error(error)
                callback()
                return
              }
              if (response.responsecode == 200) {
                vm.loading = false
                vm.$emit('addHoliday', response.data[0])
                vm.$emit('closeModal')
              }
            }
          )
        }
      })
    },

    update(data) {
      let vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        } else {
          vm.loading = true
          api.updategeneraliholiday(data, function (error, response) {
            if (error) {
              console.error(error)
              callback()
              return
            }
            if (response.responsecode == 200) {
              let obj = {
                date_from: data.dateFrom,
                date_to: data.dateTo,
                dayname: data.dayname,
                id: data.id,
                message: data.defaultMessage,
                pageid: data.pageid
              }
              vm.loading = false
              vm.$emit('updateHoliday', obj)
              vm.$emit('closeModal')
            }
          })
        }
      })
    }
  },
  filters: {
    dateFormat(val) {
      return val ? format(val, 'DD/MM/YYYY') : ''
    }
  },
  components: {
    Modal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/Formholiday.vue